/**
 * Utility module for managing Google Analytics integration
 */

const GOOGLE_ANALYTICS_ID = 'G-DKP1DVRLB7';

/**
 * Initialize Google Analytics on the current page
 * @returns {Function} Cleanup function to remove the scripts when component unmounts
 */
export const initializeAnalytics = () => {
    // Create and append the Google Analytics script
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(gtagScript);

    // Create and append the inline configuration script
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${GOOGLE_ANALYTICS_ID}');
    `;
    document.head.appendChild(inlineScript);

    // Return cleanup function
    return () => {
        document.head.removeChild(gtagScript);
        document.head.removeChild(inlineScript);
    };
};
